export const PatternsTableFilterData = [
    {
        "idFromColumnFilter": "name",
        "id": "name",
    },
    {
        "idFromColumnFilter": "patternL",
        "id": "patternL",
    },
    {
        "idFromColumnFilter": "patternW",
        "id": "patternW",
    },
]